import { appApi } from '../app_api';

export const eventLogsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getPlayerLogs: builder.query({
      query: (eventId) => `/events/${eventId}/registration_logs`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, eventId) => [{ type: 'EventPlayerLogs', id: eventId }],
    }),
    getScoringLogs: builder.query({
      query: (eventId) => `/events/${eventId}/scoring_logs`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, eventId) => [{ type: 'EventScoringLogs', id: eventId }],
    }),
  }),
});

export const {
  useGetPlayerLogsQuery,
  useGetScoringLogsQuery,
} = eventLogsApi;
